@if (showToggle) {
  <button
    type="button"
    class="rtoggle"
    [class.rtoggle--on]="enabled()"
    (click)="toggle()"
    [attr.aria-pressed]="enabled()"
    aria-label="Toggle redesign preview"
    title="Toggle redesign preview"
  >
    <span class="rtoggle-track"><span class="rtoggle-knob"></span></span>
  </button>
}

